import React, { useEffect, useState } from "react";
import {
  useDispatch,
  // useSelector
} from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import PageHeadingNew from "../../common-components/custom-comps/PageHeadingNew";
import { fetchFDIncentivesData } from "../../../redux/incentives-reducers/incentivesSlice";
import FDIncentivesLogs from "./FDIncentivesLogs";
import FDIncentivesForm from "./FDIncentivesForm";

const FDIncentivesStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();
  //   const { fdIncentivesLoading, fdIncentivesError, fdIncentives } = useSelector(
  //     (state) => state.incentives
  //   );

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  //   const iniAllFilter = {};
  //   const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: null,
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  function getFDIncentives(filters) {
    dispatch(
      fetchFDIncentivesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getFDIncentives(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,
    }));
  }, [isPage, pageLimit]);

  return (
    <Container className="bg-cloud-k px-50px gobal-container" fluid>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="FD Incentives Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer mod-width-50p">
          {(modValues.modName === "add" || modValues.modName === "edit") && (
            <FDIncentivesForm
              isEdit={modValues.modName === "edit"}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              userInfoData={userInfoData}
              callFunction={() => getFDIncentives(filters)}
            />
          )}
        </div>
      </Modal>

      <Row>
        <Col>
          <PageHeadingNew
            heading="FD Incentives"
            subheading="Manage FD incentive slabs for gym categories based on revenue targets"
            onReload={() => getFDIncentives(filters)}
            buttonLabel="Add New Incentive Slab"
            onButtonClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "add",
              }))
            }
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <FDIncentivesLogs
            userInfoData={userInfoData}
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            callFunction={() => getFDIncentives(filters)}
            setModValues={setModValues}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default FDIncentivesStructure;
